<template>
  <Layout>
    <PageHeader :title="title" :breadcrumbs="breadcrumbs"/>
    <form @submit="onSubmit">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body highlightable" @click="removeOpacity">
              <form class="outer-repeater">
                <div data-repeater-list="outer-group" class="outer">
                  <div data-repeater-item class="outer">

                    <div class="form-group row mt-5 mb-5">
                      <div class="col-lg-2 offset-lg-1">
                        <label
                          for="departments"
                          class="col-form-label">
                          {{ $t("tasks.talents-table.form.department") }}
                          <i
                          class="fa fa-info-circle ml-1"
                          aria-hidden="true"
                          v-b-popover.hover.bottom="$t('charlength-info.message')"
                          :title="$t('charlength-info.title')">
                          </i>
                        </label>
                      </div>
                      <div class="col-lg-6">
                        <b-form-group>
                          <b-form-select
                          v-model="$v.task.chosenDepartment.$model"
                          :options="allDepartmentsClean"
                          text-field="title"
                          value-field="id"
                          :state="validateTaskField('chosenDepartment')">
                          </b-form-select>
                          <b-form-invalid-feedback class="col-lg-6 offset-lg-1">
                            {{ $t("validation.required") }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>

                    <div class="form-group row mb-4">
                      <div class="col-lg-2 offset-lg-1">
                        <label
                          for="task-title"
                          class="col-form-label">
                          {{ $t("tasks.create.form.title.text") }}
                          <i
                          class="fa fa-info-circle ml-1"
                          aria-hidden="true"
                          v-b-popover.hover.bottom="$t('charlength-info.message')"
                          :title="$t('charlength-info.title')">
                          </i>
                        </label>
                      </div>
                      <div class="col-lg-6">
                        <b-form-group>
                          <b-form-input
                            id="task-title"
                            name="task-title"
                            type="text"
                            v-model="$v.task.title.$model"
                            class="form-control"
                            :state="validateTaskField('title')"
                          ></b-form-input>
                          <b-form-invalid-feedback class="col-lg-6 offset-lg-1">
                            {{ $t("validation.required") }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <div class="col-lg-2 offset-lg-2"></div>
                      </div>
                    </div>

                    <div class="form-group row mb-4">
                      <label class="col-form-label col-lg-2 offset-lg-1">
                        {{ $t("tasks.create.form.date.text") }}
                      </label>
                      <div class="col-lg-6">
                        <date-picker
                          type="datetime"
                          format="DD-MM-YYYY HH:mm"
                          time-title-format="HH:mm"
                          v-model="$v.task.daterange.$model"
                          range
                          :placeholder='$t("tasks.create.form.date.placeholder")'
                          append-to-body
                          :lang="locale"
                          confirm
                          class="task-create-date__calendar"
                          :input-class="{
                            'mx-input task-create-date__input': true,
                            valid: validateTaskField('daterange'),
                            invalid: validateTaskField('daterange') === false
                            }"
                        ></date-picker>
                        <b-form-invalid-feedback v-if="!$v.task.daterange.required">
                          {{ $t("validation.required") }}
                        </b-form-invalid-feedback>
                      </div>
                    </div>

                    <div class="form-group row mb-4">
                      <div class="col-lg-2 offset-lg-1">
                        <label
                          for="task-title"
                          class="col-form-label">
                          {{ $t("tasks.create.form.description.text") }}
                          <i
                          class="fa fa-info-circle ml-1"
                          aria-hidden="true"
                          v-b-popover.hover.bottom="$t('charlength-info.message')"
                          :title="$t('charlength-info.title')">
                          </i>
                        </label>
                      </div>
                      <div class="col-lg-6">
                        <b-form-textarea
                          id="task-description"
                          name="task-description"
                          class="form-control"
                          :state="validateTaskField('description')"
                          v-model="$v.task.description.$model"
                        ></b-form-textarea>
                      </div>
                      <span class="col-lg-6 offset-xl-3">
                        {{ $t("tasks.remaining-chars", {chars: getAmountOfRemainingChars()}) }}
                      </span>
                      <b-form-invalid-feedback>
                          {{ $t("validation.required") }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </div>
              </form>

              <div class="form-group row mb-4">
                <label for="departments" class="col-form-label col-lg-2 offset-lg-1">
                  {{ $t("tasks.create.form.departments-to-search.text") }}
                </label>
                <div class="col-lg-6">
                  <b-form-group>
                    <multiselect
                      v-model="selectedDepartments"
                      :options="allDepartments"
                      id="departments"
                      name="departments"
                      label="title"
                      track-by="title"
                      multiple
                      :close-on-select="false"
                      selectedLabel=""
                      selectLabel=""
                      deselectLabel=""
                      selectGroupLabel=""
                      deselectGroupLabel=""
                      placeholder=""
                      group-values="names"
                      group-label="departments"
                      :group-select="true"
                      :class="{
                        'task-create__multiselect': true,
                        }"
                      >
                    </multiselect>
                  </b-form-group>
                </div>
              </div>

              <div class="task-create--chars-exceeded__alert" v-if="getAmountOfRemainingChars() < 0">
                <b-alert show variant="danger">{{ $t("tasks.char-amount-exceeded") }}</b-alert>
              </div>

              <div class="task-create--chars-exceeded__alert" v-if="showErrorAlert">
                <b-alert show variant="danger">{{ $t("tasks.form-invalid") }}</b-alert>
              </div>

              <div class="row justify-content-start offset-lg-1" v-if="getAmountOfRemainingChars() >= 0">
                <div class="col-lg-6">
                  <button
                  type="submit"
                  class="btn btn-primary">
                  <i
                    class="fa fa-search"
                    aria-hidden="true"
                    ></i>
                    {{ $t("tasks.create.form.search-talents-button.text") }}
                  </button>
                </div>
              </div>
            </div>
            <notification-table
              v-if="areTalentsFetched"
              :talents="talents.talent"
              :allDepartments="allDepartments"
              :task="task"
              :departmentTitle="getTitleOfChosenDepartment()"
              @prepareAndPublishTask="prepareAndPublishTask($event)"
              class="mt-5"
            />
          </div>
        </div>
      </div>
    </form>
  </Layout>
</template>

<script>
import i18n from "@/i18n";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import de from "vue2-datepicker/locale/de";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import Swal from 'sweetalert2';
import router from '@/router';
import NotificationTable from "@/router/views/tasks/partials/notification-table";
import { taskService } from "@/helpers/services/tasks/taskService";
import { userService } from "@/helpers/services/user/userService";
import { required } from "vuelidate/lib/validators";
import { multiselectHelper } from '@/helpers/utils/multiselectHelper';


const page = {
    title: "Create Task",
    meta: [{ name: "description", content: appConfig.description }]
  };

const components = {
  DatePicker,
  Layout,
  PageHeader,
  NotificationTable,
  Multiselect,
  }

/**
 * Task-create component
 */
export default {
  name: "TaskCreate",
  page,
  components,
  data() {
    return {
      title: i18n.t("tasks.create.title"),
      breadcrumbs: [
        {text: i18n.t("tasks.overview.title"), href: "/tasks"},
        {text: i18n.t("tasks.create.header"), active: true},
      ],
      task: {
        title: "",
        description: "",
        qualifications: [],
        daterange: "",
        chosenDepartment: null
      },
      locale: i18n.locale,
      departments: [],
      selectedDepartments: [],
      pools: [],
      selectedPools: null,
      areTalentsFetched: false,
      talents: [],
      allPools: [],
      allDepartments: [],
      allDepartmentsClean: [],
      allQualifications: [],
      showErrorAlert: false,
    };
  },
  validations: {
    task: {
      chosenDepartment: {
        required,
      },
      title: {
        required,
      },
      daterange: {
        required,
      },
      description: {
        required,
      },
    },
  },
  methods: {
    removeOpacity() {
      document.querySelector('.highlightable').classList.remove("hasOpacity");
    },
    addOpacity() {
      document.querySelector('.highlightable').classList.add("hasOpacity");
    },
    validateField(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    validateTaskField(name) {
      const { $dirty, $error } = this.$v.task[name];
      return $dirty ? !$error : null;
    },
    async getMatchedTalents(taskSearchCriteria) {
      const talents = await taskService.searchForTalents(taskSearchCriteria);
      if (talents) {
        this.talents = talents;
        this.areTalentsFetched = true;
      }
    },
    onSubmit(e) {
      e.preventDefault();

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.showErrorAlert = true;
        return;
      }

      this.showErrorAlert = false;
      this.addOpacity();
      const taskSearchCriteria = this.getTaskForSearching();
      this.getMatchedTalents(taskSearchCriteria);
    },
    getTaskForSearching() {
      const task = this.getTask();
      task.departmentIds = multiselectHelper.trimEverythingButIds(this.selectedDepartments);

      return task;
    },
    getTaskForPublishing() {
      const task = this.getTask();
      task.departmentId = this.$v.task.chosenDepartment.$model;

      return task;
    },
    getTask() {
      return {
        "title": this.$v.task.title.$model,
        "description": this.$v.task.description.$model,
        "poolIds": multiselectHelper.trimEverythingButIds(this.selectedPools) ?? [],
        "startDate": this.$v.task.daterange.$model[0],
        "endDate": this.$v.task.daterange.$model[1],
        //"mandatoryQualifications" : multiselectHelper.trimEverythingButIds(this.$v.task.qualifications.$model)
      } 
    },
    prepareAndPublishTask(talentIds) {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      taskService.prepareAndPublishTask(this.getTaskForPublishing(),talentIds).then( task => {
        Swal.fire({
          icon: "success",
          title: i18n.t("tasks.status.successfully-published-swal-message", { taskTitle: task.title }),
          showConfirmButton: false,
          timer: 4000
        })
        router.push({
          name: "tasks-list"
        });
      }
      );
    },
    getAmountOfRemainingChars() {
      return taskService.getAmountOfRemainingChars(
        this.$v.task.title.$model,
        this.$v.task.description.$model,
        this.getTitleOfChosenDepartment(),
        this.getCompanyTitleOfChosenDepartment()
        );
    },
    getTitleOfChosenDepartment() {
      if (!this.allDepartments.length) {
        return "";
      }

      const chosenDepartment = this.allDepartments.find(d => d.id === this.$v.task.chosenDepartment.$model);

      if (!chosenDepartment) {
        return "";
      }

      return chosenDepartment.title;
    },
    getCompanyTitleOfChosenDepartment() {
      if (!this.allDepartments.length) {
        return "";
      }

      const chosenDepartment = this.allDepartments.find(d => d.id === this.$v.task.chosenDepartment.$model);

      return chosenDepartment?.companyTitle ?? "";
    }
  },
  created() {
    de.formatLocale.firstDayOfWeek = 1;
    userService.fetchDepartments()
    .then(departments => {
      this.allDepartmentsClean = departments;
      this.allDepartments = [{departments: i18n.t("multiselect.all"), names: departments}];
    });
    userService.fetchPools()
    .then(pools => {
      this.allPools = [{pools: i18n.t("multiselect.all"), names: pools}];
    });
    taskService.fetchMandatoryQualifications()
      .then(aq => this.allQualifications = aq);
  },
};
</script>

<style>
  .task-create--chars-exceeded__alert {
    font-weight: bold;
  }
  .hasOpacity {
    opacity: 0.6;
  }
  .step-number {
    border: 1px solid black;
    border-radius: 50%;
  }
</style>
